import { render, staticRenderFns } from "./VueTables.vue?vue&type=template&id=213dfdb1&"
import script from "./VueTables.vue?vue&type=script&lang=js&"
export * from "./VueTables.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/media/thed/vol_40/Laravel/bmat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('213dfdb1')) {
      api.createRecord('213dfdb1', component.options)
    } else {
      api.reload('213dfdb1', component.options)
    }
    module.hot.accept("./VueTables.vue?vue&type=template&id=213dfdb1&", function () {
      api.rerender('213dfdb1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/admin/components/VueTables.vue"
export default component.exports